module.exports = __webpack_public_path__ + "static/media/Deforestation_bg.61b21412.jpg";